import { render } from "./BuatTagihanPage.vue?vue&type=template&id=233bae68&scoped=true"
import script from "./BuatTagihanPage.vue?vue&type=script&lang=js"
export * from "./BuatTagihanPage.vue?vue&type=script&lang=js"

import "./BuatTagihanPage.vue?vue&type=style&index=0&id=233bae68&scoped=true&lang=css"
import "./BuatTagihanPage.vue?vue&type=style&index=1&id=233bae68&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-233bae68"]])

export default __exports__